<template>
    <div class="has-text-centered">
        <h3 class="subtitle is-3">Errore 404</h3>
        <h1 class="title is-1">Pagina non trovata</h1>
    </div>
</template>